import { QueryClient, type DefaultOptions } from 'react-query'

import { queryClientDefaultOptions } from '@webapp/api/queryClient'

const testQueryClientDefaultOptions: DefaultOptions = {
  ...queryClientDefaultOptions,
  queries: {
    ...queryClientDefaultOptions.queries,
    cacheTime: Infinity,
  },
}

let queryClient: QueryClient

export const getQueryClient = (): QueryClient => queryClient

export const initializeQueryClient = (): QueryClient => {
  queryClient = new QueryClient({
    defaultOptions: testQueryClientDefaultOptions,
  })

  return queryClient
}
